// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2ZhHv","rootCenter":"LoadMoreObserver_rootCenter__QmUE9","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__gIIN0"};